import axios from '@/utils/request'

export default {
	// 2021-01-04
	findByWarehouseId(warehouseId) {
		return axios.get('/mms/user-warehouses/find-by-warehouse-id/' + warehouseId)
	},
	// 2021-01-04
	insertBatch(params) {
		return axios.post('/mms/user-warehouses/insert-batch', params)
	},
	// 2021-01-04
	delete(id) {
		return axios.delete('/mms/user-warehouses/' + id)
	},
	// 2021-01-04
	findByUserId(userId) {
		return axios.get('/mms/user-warehouses/find-by-user-id/' + userId)
	}
}

